import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/

.breadcrumb-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.breadcrumb-item a {
  color: var(--p-text-color);
  text-decoration: none;
  font-size: var(--p-font-size-small);
  text-underline-offset: 2px;
}

.breadcrumb-item a:hover {
  text-decoration: underline;
}

.breadcrumb-item.current a {
  opacity: var(--p-text-meta-opacity);
}

.breadcrumb-item.current a:hover {
  text-decoration: none;
}

svg {
  margin: 0 0.6rem;
}


`;
